
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Alltypesoftough() {



  const cardData =
  {
    keyword: ' All Types of Toughened Glass Work',
    heading: 'Anjali Enterprises: All Types of Toughened Glass Work',
    headingDescription: 'When it comes to toughened glass work in Pune, Anjali Enterprises stands out as a leader in providing high-quality glass solutions tailored to your needs. Our toughened glass services are designed to enhance safety, functionality, and aesthetic appeal. Whether you require custom designs, safety glass installation, or durable glass partitions, we are committed to delivering superior results that exceed expectations.',

    topPlaces: [
        {
          title: "Toughened Glass Work in Pune",
          description: "Anjali Enterprises offers top-notch toughened glass work in Pune, providing reliable and efficient services that ensure your space is both safe and stylish. Our expertise covers a wide range of glass services, from installations to custom solutions."
        },
        {
          title: "Glass Toughening Services",
          description: "Our glass toughening services transform regular glass into a stronger, safer material. We use advanced techniques to ensure that the toughened glass meets all safety standards while offering the desired clarity and durability."
        },
        {
          title: "Safety Glass Installation",
          description: "We specialize in the installation of safety glass, ensuring your office or home is protected with high-quality glass that’s strong and resistant to breaking. This is perfect for high-traffic areas, doors, and windows."
        },
        {
          title: "Toughened Glass Partitions",
          description: "Create modern and functional office spaces with toughened glass partitions. Our partitions are ideal for dividing rooms while maintaining an open, light-filled environment."
        },
        {
          title: "Custom Toughened Glass",
          description: "Our team works closely with clients to design custom toughened glass solutions that meet your specific requirements, whether for doors, windows, or decorative features."
        },
        {
          title: "Laminated Glass Work",
          description: "We provide laminated glass work that ensures both strength and safety. Our laminated glass solutions are perfect for areas that require extra security and durability."
        },
        {
          title: "Tempered Glass Installation in Pune",
          description: "Anjali Enterprises offers professional tempered glass installation services in Pune. Whether you need tempered glass for windows, doors, or other applications, we ensure precise installation with high-quality glass."
        },
        {
          title: "Toughened Glass for Windows",
          description: "Our toughened glass for windows combines strength and clarity, providing both safety and aesthetic appeal. These windows are resistant to impact and breakage, offering lasting protection."
        },
        {
          title: "Glass Doors",
          description: "We specialize in the installation of toughened glass doors, providing a sleek, modern look while maintaining durability and safety. These doors are ideal for commercial and residential spaces."
        },
        {
          title: "Toughened Glass for Showers",
          description: "Upgrade your bathroom with toughened glass for showers. Our glass solutions offer elegance and functionality, ensuring that your shower area is both stylish and safe."
        },
        {
          title: "Toughened Glass Cladding",
          description: "Add a sophisticated touch to your building with toughened glass cladding. This solution enhances the exterior of your building while providing strength and weather resistance."
        },
        {
          title: "Decorative Toughened Glass",
          description: "Our decorative toughened glass services allow you to create unique, beautiful designs for your space. Whether for partitions or windows, we offer customized options that reflect your style."
        },
        {
          title: "Toughened Glass Partitions for Offices",
          description: "Our toughened glass partitions for offices help create functional and visually appealing workspaces. These partitions are ideal for maintaining an open and collaborative atmosphere while dividing different office areas."
        }
      ],
      tableData: [
        ["- Toughened Glass Work in Pune", "- Glass Toughening Services"],
        ["- Safety Glass Installation", "- Toughened Glass Partitions"],
        ["- Custom Toughened Glass", "- Laminated Glass Work"],
        ["- Tempered Glass Installation in Pune", "- Toughened Glass for Windows"],
        ["- Glass Doors", "- Toughened Glass for Showers"],
        ["- Toughened Glass Cladding", "- Decorative Toughened Glass"],
        ["- Toughened Glass Partitions for Offices", ""]
      ],


   

   "whychoose": [
  {
    "WhyChooseheading": "Specialized Toughened Glass Solutions",
    "WhyChoosedescription": "At Anjali Enterprises, we specialize in providing high-quality toughened glass solutions for a variety of applications. Whether it's for windows, doors, partitions, or facades, we offer durable and reliable toughened glass that meets your specific needs."
  },
  {
    "WhyChooseheading": "Custom Designs and Sizes",
    "WhyChoosedescription": "We understand that every project is unique. Our toughened glass can be customized in different shapes, sizes, and designs to suit the requirements of your space, ensuring both functionality and aesthetics."
  },
  {
    "WhyChooseheading": "Safety and Strength",
    "WhyChoosedescription": "Toughened glass is known for its safety and strength. It is heat-treated to withstand high pressure and force, making it an ideal choice for applications that require extra durability. We ensure that all our toughened glass meets the highest safety standards."
  },
  {
    "WhyChooseheading": "Durability and Long-Lasting",
    "WhyChoosedescription": "Our toughened glass is not only strong but also highly resistant to breakage and damage. This ensures that your investment lasts for many years, making it a cost-effective solution for both residential and commercial properties."
  },
  {
    "WhyChooseheading": "Timely Delivery and Installation",
    "WhyChoosedescription": "We value your time and ensure that all orders are completed and installed on time. Our team handles the installation process professionally and efficiently, causing minimal disruption to your space."
  },
  {
    "WhyChooseheading": "Affordable Pricing",
    "WhyChoosedescription": "Anjali Enterprises offers toughened glass solutions at competitive and transparent pricing. We provide high-quality products without compromising on cost, ensuring you get the best value for your money."
  },
  {
    "WhyChooseheading": "Expert Team",
    "WhyChoosedescription": "Our team consists of trained professionals who are well-versed in handling toughened glass installations. From design consultation to final installation, we ensure that every aspect of the project is carried out with care and expertise."
  },
  {
    "WhyChooseheading": "Customer Satisfaction",
    "WhyChoosedescription": "We have a proven track record of customer satisfaction, with many clients returning for our services and recommending us to others. We aim to provide exceptional service and high-quality toughened glass for every project."
  }
]


  }

  const faqData = [
    {
      question: "What is toughened glass, and why is it used?",
      answer: "Toughened glass is heat-treated to increase its strength and safety. It is commonly used in areas where safety and durability are essential, such as windows, partitions, and glass doors."
    },
    {
      question: "Can you customize the size and design of the toughened glass?",
      answer: "Yes, we offer toughened glass in custom sizes and designs to meet your specific requirements, whether it's for home, office, or commercial use."
    },
    {
      question: "How do I ensure the toughened glass is suitable for my project?",
      answer: "Our team will provide a free consultation to assess your project needs and help you choose the best type of toughened glass, ensuring it fits both your design and functional requirements."
    },
    {
      question: "How long does it take to install toughened glass?",
      answer: "The installation time varies depending on the complexity and size of the project. However, we ensure timely completion without compromising quality."
    },
    {
      question: "Is toughened glass safe?",
      answer: "Yes, toughened glass is much stronger than regular glass and, when it breaks, it shatters into small, less harmful pieces, making it safer to use in various applications."
    },
    {
      question: "Can toughened glass be used for both residential and commercial purposes?",
      answer: "Yes, toughened glass is suitable for both residential and commercial spaces. It is commonly used in windows, doors, partitions, facades, and shower enclosures."
    },
    {
      question: "Do you offer any warranties on your toughened glass?",
      answer: "Yes, we provide warranties on our toughened glass products, ensuring that you receive a durable and long-lasting solution for your project."
    },
    {
      question: "Can you install toughened glass in existing structures?",
      answer: "Absolutely! We can retrofit toughened glass into existing spaces, ensuring it fits perfectly with your current setup."
    },
    {
      question: "How do I get a quote for toughened glass installation?",
      answer: "Simply contact us for a free consultation. We will assess your needs and provide a competitive and transparent quote for your project."
    },
    {
      question: "What makes Anjali Enterprises different from other toughened glass suppliers?",
      answer: "Anjali Enterprises stands out due to our focus on quality, customization, and customer satisfaction. Our team is dedicated to delivering durable and aesthetically pleasing toughened glass solutions, backed by expert installation and affordable pricing."
    }
  ];
  
  const testimonials = [
    {
      name: "Mr. Rajeev Gupta",
      text: "We needed toughened glass for our office partitions, and Anjali Enterprises delivered exactly what we wanted. The glass is strong and looks great. Their professional service made the entire process smooth."
    },
    {
      name: "Mrs. Sunita Joshi",
      text: "Anjali Enterprises installed toughened glass in our home, and we couldn’t be happier. The glass is perfect for our modern design, and the installation was quick and efficient. Highly recommended!"
    }
  ];
  



  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>


<Helmet>
  <title>Toughened Glass Work Services in Pune | Anjali Enterprises </title>
  <meta name="description" content="Anjali Enterprises offers all types of Toughened Glass Work in Pune, including glass toughening, safety glass installation, custom toughened glass, and partitions. Call +91 8793220265 for expert services." />
  <meta name="keywords" content="Toughened Glass Work in Pune, Glass Toughening Services, Safety Glass Installation, Toughened Glass Partitions, Custom Toughened Glass, Laminated Glass Work, Tempered Glass Installation Pune, Toughened Glass for Windows, Glass Doors, Toughened Glass for Showers, Toughened Glass Cladding, Decorative Toughened Glass, Toughened Glass Partitions for Offices" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Toughened Glass Work Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers all types of Toughened Glass Work in Pune, including glass toughening, safety glass installation, custom toughened glass, and partitions. Call +91 8793220265 for expert services." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/toughened-glass-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/toughened-glass-work" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers all types of Toughened Glass Work in Pune, including glass toughening, safety glass installation, custom toughened glass, and partitions. Call +91 8793220265 for expert services.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/toughened-glass-work",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/toughened-glass-service.jpg",
        "priceRange": "₹1000 - ₹15000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/toughened-glass-work",
          "priceCurrency": "INR",
          "price": "1000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.6",
          "reviewCount": "38"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Amit R"
            },
            "datePublished": "2024-07-15",
            "reviewBody": "Anjali Enterprises installed toughened glass for our office partitions. The service was impeccable, and the quality of the glass was excellent. Highly recommend!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Pooja L"
            },
            "datePublished": "2024-10-03",
            "reviewBody": "We got custom toughened glass for our home showers. The installation was perfect, and the glass looks stunning. Thanks to Anjali Enterprises for the great service!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/toughened-glass-work"
        },
        "keywords": "Toughened Glass Work in Pune, Glass Toughening Services, Safety Glass Installation, Toughened Glass Partitions, Custom Toughened Glass, Laminated Glass Work, Tempered Glass Installation Pune, Toughened Glass for Windows, Glass Doors, Toughened Glass for Showers, Toughened Glass Cladding, Decorative Toughened Glass, Toughened Glass Partitions for Offices"
      }
    `}
  </script>
</Helmet>



      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/2.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Alltypesoftough;